import { Route, Routes } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { withAuth } from '@verantos-dev/core-auth';
import { appIdToClaimCheckDefinitionMap } from '@verantos-dev/core-constants';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { AvLibraryPage } from '@verantos-dev/feature-av-library';

const APP_ID = EvidencePlatformSidebarAppID.analyticalVariables;

export const AnalyticalVariablesUiRoutes = () => {
  useAppId(APP_ID);

  return (
    <Routes>
      <Route index element={<AvLibraryPage />} />
    </Routes>
  );
};

export default withAuth(AnalyticalVariablesUiRoutes, APP_ID, appIdToClaimCheckDefinitionMap);
